import { render, staticRenderFns } from "./vacancy-tariff-dialog.vue?vue&type=template&id=580dd776&"
import script from "./vacancy-tariff-dialog.vue?vue&type=script&lang=js&"
export * from "./vacancy-tariff-dialog.vue?vue&type=script&lang=js&"
import style0 from "./vacancy-tariff-dialog.vue?vue&type=style&index=0&id=580dd776&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports